import * as React from 'react';
import { Component } from 'react';
import './MessageActionsButton.css';

interface Props {
  onSendClick: () => void;
  onSaveClick: () => void;
  onScheduleClick?: () => void;
  isDisabled?: boolean;
  onActiveActionChange?: (actionType: ACTION_TYPE) => void;
  isLoading?: boolean;
}

interface State {
  title: string;
  isExpanded: boolean;
  activeAction: ACTION_TYPE;
}

export enum ACTION_TYPE {
  SAVE = 'SAVE',
  SEND = 'SEND',
  SCHEDULE = 'SCHEDULE'
}

export class GeneralMessageActionsButton extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      title: 'Send now',
      isExpanded: false,
      activeAction: ACTION_TYPE.SEND
    };
  }

  onSelectedSend = () => {
    this.onActiveActionChange(ACTION_TYPE.SEND);
    this.setState({ title: 'Send now', activeAction: ACTION_TYPE.SEND, isExpanded: false });
  };

  onSelectedSave = () => {
    this.onActiveActionChange(ACTION_TYPE.SAVE);
    this.setState({ title: 'Save draft', activeAction: ACTION_TYPE.SAVE, isExpanded: false });
  };

  onSelectedSchedule = () => {
    this.onActiveActionChange(ACTION_TYPE.SCHEDULE);
    this.setState({ title: 'Schedule', activeAction: ACTION_TYPE.SCHEDULE, isExpanded: false });
  };

  onActiveActionChange = (actionType: ACTION_TYPE) => {
    if (typeof this.props.onActiveActionChange === 'function') {
      this.props.onActiveActionChange(actionType);
    }
  };

  onToggleClick = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  onActionButtonClick = () => {
    if (this.props.isLoading) {
      return;
    }
    const { activeAction } = this.state;

    switch (activeAction) {
      case ACTION_TYPE.SAVE:
        this.props.onSaveClick();
        break;
      case ACTION_TYPE.SEND:
        this.props.onSendClick();
        break;
      case ACTION_TYPE.SCHEDULE:
        this.props.onScheduleClick();
        break;
      default:
        console.error(`GeneralMessageActionButton.tsx: Unexpected ACTION_TYPE ${activeAction}`);
    }
  };

  renderDropdownList() {
    if (!this.state.isExpanded) {
      return null;
    }

    return (
      <div className="gmActionDropdown">
        <button type="button" onClick={this.onSelectedSend}>
          Send now
        </button>
        <button type="button" onClick={this.onSelectedSchedule}>
          Schedule sending
        </button>
        <button type="button" onClick={this.onSelectedSave}>
          Save draft
        </button>
      </div>
    );
  }

  render() {
    const isPrimaryDisabled = Boolean(
      this.props.isLoading || (this.props.isDisabled && this.state.activeAction !== ACTION_TYPE.SAVE)
    );
    return (
      <div className="gmActionWrap">
        <div className="gmActionGroup">
          <button
            className="gmActionButton gmActionButton--primary"
            type="button"
            onClick={this.onActionButtonClick}
            disabled={isPrimaryDisabled}
          >
            {this.props.isLoading ? 'Please wait...' : this.state.title}
          </button>
          <button
            className="gmActionButton gmActionButton--primary gmActionToggle"
            type="button"
            onClick={this.onToggleClick}
            disabled={this.props.isLoading}
            aria-label="Choose send action"
          >
            v
          </button>
        </div>
        {this.renderDropdownList()}
      </div>
    );
  }
}
